


import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import firebase from 'lib/firebase';
import ClipLoader from "react-spinners/ClipLoader";
import { Container, Col, Row } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import moment from 'moment';
import axios from 'axios';

import * as AdminActions from 'store/modules/AdminModule';

import api from 'lib/api';
import global from 'lib/global';

import Pagination from './Pagination';

class PaidRegisterScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            isTabType: 6, // 6 또는 7만 사용
            listSearchText: '',
        }
    }


    componentDidMount() {
        this.props.adminActions.getAdminRegisterList({
            page: 0,
            type: 0,
            user: 0,
        })
    }

    onChangePage = (pageIdx) => {
        this.props.adminActions.getAdminRegisterList({
            page: pageIdx,
            type: this.state.isTabType,
        })
        this.setState({ page: pageIdx })
    }

    onChangeInputTutorSearch = (e) => {
        let searchInput = e.target.value;

        this.props.adminActions.getAdminRegisterList({
            page: 0,
            type: 1,
            user: 0,
            search: searchInput
        })

        this.setState({
            listSearchText: searchInput,
        });
    }

    tableCellIndexFormatter = (cell) => {
        return (
            <div onClick={() => this.onClickUser(cell)}>{cell}</div>
        )
    }

    tableCellDateFormatter = (cell) => {
        return (
            <div>{cell ? moment(cell).format('YYYY-MM-DD') : null}</div>
        )
    }

    tableCellTypeFormatter = (cell) => {
        return (
            <div>{cell == 1 ? '단기' : '정기'}</div>
        )
    }


    render() {
        const registerData = this.props.adminRegisterList.list ? this.props.adminRegisterList.list : [];

        return (
            <div id='paidRegister'>
                <div id='functionContainer'>
                    <div id='adminSearch'>
                        <input
                            id='adminSearchInput'
                            type="text"
                            maxLength={30}
                            onChange={this.onChangeInputTutorSearch}
                            value={this.state.listSearchText}
                            placeholder={"Name, Email"} />
                        <img src={"/write/icon_search.png"} alt="search" />
                    </div>
                    {/* 페이지 */}
                    <Pagination
                        maxPage={this.props.adminRegisterList.page_all ? this.props.adminRegisterList.page_all : 0}
                        isPage={this.state.page}
                        onPagination={this.onChangePage} />
                </div>

                <div id='table'>
                    <BootstrapTable
                        keyField='idx'
                        classes='table'
                        headerWrapperClasses='tableHeader'
                        bodyClasses='tableBody'
                        bordered={true}
                        data={registerData}
                        columns={[
                            {
                                dataField: 'idx', text: 'No',
                                headerClasses: 'table_width60', classes: 'table_width60',
                                formatter: this.tableCellIndexFormatter
                            },
                            {
                                dataField: 'nick_name', text: 'Name',
                                headerClasses: 'table_width200', classes: 'table_width200'
                            },
                            {
                                dataField: 'title', text: 'Title',
                                headerStyle: { textAlign: 'center' }
                            },
                            {
                                dataField: 'level', text: 'Lv',
                                headerClasses: 'table_width60', classes: 'table_width60',
                            },
                            {
                                dataField: 'pay_type', text: 'Type',
                                headerClasses: 'table_width60', classes: 'table_width60',
                                formatter: this.tableCellTypeFormatter
                            },
                            {
                                dataField: 'pay_month', text: 'Mon',
                                headerClasses: 'table_width60', classes: 'table_width60',
                            },
                            {
                                dataField: 'pay_money', text: 'Pay',
                                headerClasses: 'table_width100', classes: 'table_width100',
                            },
                            {
                                dataField: 'pay_date', text: 'Date(start)',
                                headerClasses: 'table_width150', classes: 'table_width150',
                                formatter: this.tableCellDateFormatter
                            },
                            {
                                dataField: 'pay_end', text: 'Date(End)',
                                headerClasses: 'table_width150', classes: 'table_width150',
                                formatter: this.tableCellDateFormatter
                            },
                            {
                                dataField: 'pay_code', text: 'PayCode',
                                headerClasses: 'table_width150', classes: 'table_width150',
                                formatter: this.tableCellDateFormatter
                            },
                        ]} />
                </div>
            </div>
        );
    }
}



let mapStateToProps = (state) => ({
    adminRegisterList: JSON.parse(JSON.stringify(state.AdminModule.get('adminRegisterList'))),
});

let mapDispatchToProps = (dispatch) => ({
    adminActions: bindActionCreators(AdminActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaidRegisterScreen);

